module.exports = __webpack_public_path__ + "img/agent.81c93626.png";